import { Select } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { accountTreeModel } from 'entities/account';
import { DashboardPeriod } from 'shared/api';
import { PERIOD_OPTIONS, TIME_ZONE_OPTIONS } from '../../config';
import { dashboardPageModel } from '../../model';
import cls from './dashboard-filter.module.scss';

export const DashboardFilter = () => {
	const { t } = useTranslation();

	const [period, timeZone, currency, currencies, setPeriod, setTimeZone, setCurrency] = useUnit([
		dashboardPageModel.$period,
		dashboardPageModel.$timeZone,
		dashboardPageModel.$currency,
		accountTreeModel.$currencies,
		dashboardPageModel.setPeriod,
		dashboardPageModel.setTimeZone,
		dashboardPageModel.setCurrency,
	]);

	const currencyOptions = currencies.includes('USD') ? currencies : ['USD', ...currencies];

	return (
		<div className={cls.dashboardFilter}>
			<Select
				label={t('dashboard-page.filters.period')}
				data={PERIOD_OPTIONS.map((option) => ({
					value: option.value,
					label: t(option.labelKey),
				}))}
				value={period}
				allowDeselect={false}
				clearable={false}
				className={cls.dashboardFilterField}
				onChange={(value) => value && setPeriod(value as DashboardPeriod)}
			/>
			<Select
				label={t('dashboard-page.filters.time-zone')}
				data={TIME_ZONE_OPTIONS}
				value={timeZone}
				allowDeselect={false}
				clearable={false}
				className={cls.dashboardFilterField}
				onChange={(value) => value && setTimeZone(value)}
			/>
			<Select
				label={t('dashboard-page.filters.currency')}
				data={currencyOptions}
				value={currency}
				allowDeselect={false}
				clearable={false}
				className={cls.dashboardFilterField}
				onChange={(value) => value && setCurrency(value)}
			/>
		</div>
	);
};
